import styled from 'styled-components';

const Column = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;

  &:not(:last-of-type) {
    margin-bottom: 1em;
    margin-right: 0em;

    @media only screen and (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
      margin-bottom: 0em;
      margin-right: 1em;
    }
  }
`;

export default Column;
